import React, {Component} from "react";
import Table from "../../components/Table";
import EdiMessageItem from "./EdiMessageItem";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import PaginatorButton from "../../components/PaginatorButton";
import {fromJS, Map, List} from "immutable";
import {graphql} from "react-apollo";
import {EDI_MESSAGES} from "../../queries/shipping";

class EdiMessagesList extends Component {

  render() {
    let {loading, error, incomingEdiMessages} = this.props.data;
    if (error) return <GraphQLErrors error={error} />
    let tableHeader = List([
      "Id",
      "Type",
      "Order Id",
      "Status",
      "Updated",
    ])          
    let incomingEdiMessagesData = fromJS(incomingEdiMessages || []);
    // 
    return (
      <div>
        <Table 
          data={incomingEdiMessagesData.get("entries", List())} 
          renderer={EdiMessageItem} 
          onItemClick={this.handleItemClick.bind(this)}
          tableHeader={tableHeader}
          extraClassName="EdiMessagesList"
          itemKey="id"
          mode="table"
          showCount={true}
          selected={this.props.selectedId}
          />
        <Loading show={loading && incomingEdiMessagesData.size === 0} />
        <PaginatorButton 
          metadata={incomingEdiMessagesData.get("metadata", Map())} 
          onNext={this.handleNext.bind(this)}
          showLoading={loading}
          />
      </div>
    )
  }

  handleNext(afterId) {
    this.props.data.fetchMore({
      variables: {
        pagination: {
          after: afterId
        }
      },
      updateQuery: (prev, {fetchMoreResult}) => {
        if (!fetchMoreResult) return prev;
        return {
          incomingEdiMessages: {
            __typename: prev.incomingEdiMessages.__typename,
            metadata: fetchMoreResult.incomingEdiMessages.metadata,
            entries: [...prev.incomingEdiMessages.entries, ...fetchMoreResult.incomingEdiMessages.entries]
          }
        }
      }
    })
  }  


  handleItemClick(itemData, e, field = "") {
    this.props.onSelectionChange(itemData);
  }  
}

const withQuery = graphql(EDI_MESSAGES, {
  options: (props) => ({
    fetchPolicy: "cache-and-network",
    variables: {
      filter: {
        status: props.statusFilter,
        orderId: props.orderIdSearch,
        filename: props.filenameSearch
      }
    }    
  })
})

export default withQuery(EdiMessagesList);